<div data-testid="delivery-result-view-page" class="inbound-form-wrapper-container">
  <!-- Sticky Header -->
  <div class="sticky-header">
    <div class="flex justify-between items-center mb-5">
      <h2 class="text-2xl font-semibold text-gray-800">
        {{ "outbound_management.view.result_title" | translate }}
      </h2>
      <div class="flex gap-3">
        <app-button
          [testId]="'delivery-result-view-back-btn'"
          [label]="'common.actions.back' | translate"
          (emitOnClick)="onBackClick()"
          [outlined]="true"
          type="secondary"
        ></app-button>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="inbound-form-wrapper-content">
    <div class="p-2">
      @if (loading()) {
        <div class="flex justify-center items-center py-8">
          <p-progressSpinner data-testid="delivery-result-view-loading"></p-progressSpinner>
        </div>
      } @else {
        @if (resultData()) {
          <!-- Basic Information Section -->
          <section class="form-section pl-6 mb-4 notice-basic-section">
            <div class="flex items-center px-4">
              <h2 class="section-title text-lg font-semibold mr-4">
                {{
                  "outbound_management.sections.basic_information" | translate
                }}
              </h2>
            </div>
            <div class="grid gap-2 pl-8 pr-4 py-2 grid-cols-4">
              <!-- Row 1: Outbound Type, Result Code, Outbound Status, ODO Code -->
              <div class="form-field">
                <label class="form-label text-sm font-semibold text-gray-700">
                  {{ "outbound_management.fields.outbound_type" | translate }}
                </label>
                <p class="text-sm text-gray-800 mt-1">
                  {{ getOutboundTypeLabelValue() }}
                </p>
              </div>
              <div class="form-field">
                <label class="form-label text-sm font-semibold text-gray-700">
                  {{
                    "outbound_management.table.columns.outbound_result_number"
                      | translate
                  }}
                </label>
                <p class="text-sm text-gray-800 mt-1">
                  {{ getFieldValue("resultCode") || "-" }}
                </p>
              </div>
              <div class="form-field">
                <label class="form-label text-sm font-semibold text-gray-700">
                  {{ "outbound_management.fields.outbound_status" | translate }}
                </label>
                <div class="mt-1">
                  <p-tag
                    data-testid="delivery-result-view-status-tag"
                    [value]="getStatusLabel(getFieldValue('status'))"
                    [ngClass]="getStatusTagClass(getFieldValue('status'))"
                    styleClass="status-tag"
                  />
                </div>
              </div>
              <div class="form-field">
                <label class="form-label text-sm font-semibold text-gray-700">
                  {{
                    "outbound_management.table.columns.outbound_notice_number"
                      | translate
                  }}
                </label>
                <p class="text-sm text-gray-800 mt-1">
                  {{ getFieldValue("odoCode") || "-" }}
                </p>
              </div>
              <!-- Row 2: Order Code, Creation Time -->
              <div class="form-field">
                <label class="form-label text-sm font-semibold text-gray-700">
                  {{
                    "outbound_management.table.columns.order_code" | translate
                  }}
                </label>
                <p class="text-sm text-gray-800 mt-1">
                  {{ getFieldValue("orderCode") || "-" }}
                </p>
              </div>
              <div class="form-field">
                <label class="form-label text-sm font-semibold text-gray-700">
                  {{
                    "outbound_management.table.columns.creation_time"
                      | translate
                  }}
                </label>
                <p class="text-sm text-gray-800 mt-1">
                  {{ formatDate(getFieldValue("creationDate")) || "-" }}
                </p>
              </div>
            </div>
          </section>

          <!-- Warehouse Information Section -->
          <section class="form-section pl-6 mb-4 notice-basic-section">
            <div class="flex items-center px-4">
              <h2 class="section-title text-lg font-semibold mr-4">
                {{
                  "outbound_management.sections.warehouse_information"
                    | translate
                }}
              </h2>
            </div>
            <div class="grid gap-2 pl-8 pr-4 py-2 grid-cols-4">
              <div class="form-field">
                <label class="form-label text-sm font-semibold text-gray-700">
                  {{
                    "outbound_management.table.columns.outbound_warehouse_or_store"
                      | translate
                  }}
                </label>
                <p class="text-sm text-gray-800 mt-1">
                  @if (isTransferOrder()) {
                    {{ getFieldValue("outLogicWarehouseName") || "-" }}
                  } @else {
                    {{ getFieldValue("shopName") || "-" }}
                  }
                </p>
              </div>
            </div>
          </section>

          <!-- Item Details Section -->
          <section class="form-section mb-4">
            <div class="flex items-center mb-2 px-4">
              <h2 class="section-title text-lg font-semibold mr-4">
                {{ "outbound_management.sections.item_details" | translate }}
              </h2>
            </div>
            <div class="pl-6 ml-4 py-1">
              @if (productDetails().length > 0) {
                <app-data-table
                  data-testid="delivery-result-view-product-table"
                  [columns]="productTableColumns()"
                  [dataSource]="productDetails()"
                  [loading]="loading()"
                  [hasCheckColumn]="false"
                  [totalRecords]="productDetails().length"
                  [first]="0"
                  [rows]="20"
                ></app-data-table>
              } @else {
                <div class="text-center text-gray-500 py-4">
                  {{
                    "outbound_management.messages.no_products_selected"
                      | translate
                  }}
                </div>
              }
            </div>
          </section>
        }
      }
    </div>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="delivery-result-view-toast"></p-toast>
